;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { cn } from '../../utils/cn'
import { Tooltip } from './_tooltip/_tooltip'
import { type HelpContent } from './_tooltip/_tooltip-content'
import { getHelpAccessibleName } from './_tooltip/get-accessible-name'
import { BaseButton } from './base-button'
import { Icon } from './icon'

export function HelpIcon({
  help,
  rumTooltipName,
  className,
}: {
  help: HelpContent
  rumTooltipName?: string
  className?: string
}) {
  return (
    <Tooltip help={help} rumTooltipName={rumTooltipName}>
      <BaseButton
        className={cn('cursor-help', className)}
        aria-label={getHelpAccessibleName(help)}
      >
        <Icon
          name="heroicons/outline/question-mark-circle"
          className="size-4.5"
        />
      </BaseButton>
    </Tooltip>
  )
}
